import orderBy from 'lodash/orderBy';

const orderByName = (array) => orderBy(array, 'name', 'asc');

export default orderByName;
